import { BinaryTree, TEMPLATE_NODE } from './binary-tree';
import { BinaryTreeNode } from './binary-tree-node';
import { CoordinatorService } from './coordinator.service';
import { Report } from './report';
import { ScriptBase } from './script-base';
import { ScriptHitset } from './script-hitset';
import { ScriptNode } from './script-node';

export class ScriptTags extends ScriptBase {
    #coords: CoordinatorService;
    #bt: BinaryTree;

    constructor(coords: CoordinatorService, _bt: BinaryTree) {
        super(coords, _bt);
        this.#coords = coords;
        this.#bt = _bt;
    }

    get type() {
        return this.#bt.type!;
    }

    

    addToReport(r: Report) {
        r.addBinaryTree(this.#bt.type!, this.#bt);
    }

    hitset(isPreview = false) {
        const nH = new ScriptHitset(this.#coords, isPreview);
               const s = new Set<string>();
        this.#bt.root.descendants.forEach((btn) => {
            btn.activeIdSet().forEach((id) => s.add(id));
        });
        return this._hitset(nH, s);
    }
    delete(withItems = false) {
        if (withItems === true || this.hitset().size === 0) this.#bt.delete();
    }

    get root() {
        return this.#bt.root.scriptClass;
    }

    node(path: string | string[], isCreate = false): ScriptNode | ScriptNode[] | null {
        let isSingle = false;
        if (!Array.isArray(path)) {
            isSingle = true;
            path = [path];
        }

        const respLs: ScriptNode[] = [];
        path.forEach((p) => {
            let nd: BinaryTreeNode | null;
            nd = this.#bt.getNodeFromId(p);
            if (!nd) nd = this.#bt.getNodeFromPath(p, isCreate);
            nd && respLs.push(nd.scriptClass);
        });
        return isSingle ? respLs[0] || null : respLs;
    }

    log(prefix = '') {
        console.log(`${prefix} ${this.type}: ${this.#bt.title}`);
        return this;
    }

    json() {
        return this.#bt.save();
    }

    values() {
        const v = this.#bt.values() as any;
        if (!v) return;
        delete v.ownerId;
        delete v.id;

        return { nodesItems: v, id: this.#bt.id };
    }

    display(isPreview = false) {
        this.hitset(isPreview).display();
        return this;
    }

    createNodesFromTemplate(ls: TEMPLATE_NODE[]) {
        this.#bt.createNodesFromTemplate(ls);
        return this;
    }
}
